// Mutations
export const SET_DAILY_TASKS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dailyTasks.data = payload
    state.dailyTasks.lastUpdate = new Date()
  }
}
export const ADD_DAILY_TASKS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.dailyTasks.data.tasks.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.dailyTasks.data.tasks.push(data)
      }
    })
  }
}
export const SET_DAILY_TASKS_LOADING = (state, payload) => {
  state.dailyTasks.loading = payload
}

export const SET_PROFESSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professional.data = payload
    state.professional.lastUpdate = new Date()
  }
}
export const ADD_PROFESSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.professional.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.professional.data.push(data)
      }
    })
  }
}
export const SET_PROFESSIONAL_LOADING = (state, payload) => {
  state.professional.loading = payload
}

export const SET_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clients.data = { ...payload }
    state.clients.lastUpdate = new Date()
  }
}
export const ADD_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.clients.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clients.data.push(data)
      }
    })
  }
}
export const SET_CLIENTS_LOADING = (state, payload) => {
  state.clients.loading = payload
}

export const SELECT_ALL_CLIENTS = (state, payload) => {
  state.clients.selected = payload
}

export const DONE_CLIENTS = (state, payload) => {
  state.clients.selected = payload.length
    ? payload.map((task) => {
        return task.id
      })
    : []
}

export const CHANGE_SHOW_MODAL_ASSIGN = (state, payload) => {
  state.showModalAssign = payload
}

export const SET_ID_MODAL_ASSIGN = (state, payload) => {
  state.idModalAssign = payload
}

export const SET_INFO_ALERT = (state, payload) => {
  const assigned = state.clients.selected

  const unassigned =
    state.clients.data.value.task_detail.length - assigned.length

  state.dailyTasks.data.tasks.map((task) => {
    if (payload.id === task.id) {
      task.assigned = assigned.length
      task.unassigned = unassigned
    }
    return task
  })

  state.modalInfoAlert = payload
}

export const CLEAR_INFO_ALERT = (state, payload) => {
  state.modalInfoAlert = null
}

export const SET_IMPORT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.import.data = payload
    state.import.lastUpdate = new Date()
  }
}
export const ADD_IMPORT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.import.data.tasks.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.import.data.tasks.push(data)
      }
    })
  }
}
export const SET_IMPORT_LOADING = (state, payload) => {
  state.import.loading = payload
}

export const SET_EXPORT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.export.data = payload
    state.export.lastUpdate = new Date()
  }
}
export const ADD_EXPORT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.export.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.export.data.push(data)
      }
    })
  }
}
export const SET_EXPORT_LOADING = (state, payload) => {
  state.export.loading = payload
}
